import API from "../../../API/API";

const api = new API();
const endPoints = "signin";

export const postLoginApi = async (data) => {
  // skipErrorHandling: true — login errors are fully handled by signInAction.
  // Without this, API.js would treat a 401 (wrong password) as a session expiry
  // and call window.location.href = "/", causing an unexpected page reload.
  return api.post(endPoints, data, { skipErrorHandling: true });
};
